import {PurchaseApprovalStatus} from "./PurchaseApprovalStatus";

export const PurchaseApprovalStatusColors: Record<PurchaseApprovalStatus, "primary" | "secondary" | "info" | "warning" | "error" | "success" | "default"> = {
  [PurchaseApprovalStatus.PENDING_REVIEW]: "warning",
  [PurchaseApprovalStatus.ERROR]: "error",
  [PurchaseApprovalStatus.VALIDATED]: "success",
};

